import React, { useEffect, useState } from 'react';

import './ScrollZone.scss';

interface ScrollZoneProps {
  containerRef: React.RefObject<HTMLDivElement>;
}

const ScrollZone = ({ containerRef }: ScrollZoneProps) => {
  const [scrolling, setScrolling] = useState<'left' | 'right' | null>(null);
  const [parent, setParent] = useState<HTMLDivElement | null>(null);
  const scrollSpeed = 3;

  const scrollContainer = (direction: 'left' | 'right') => {
    if (parent) {
      parent.scrollLeft += direction === 'left' ? -scrollSpeed : scrollSpeed;
    }
  };

  const startScrolling = (direction: 'left' | 'right') => {
    setScrolling(direction);
  };

  const stopScrolling = () => {
    setScrolling(null);
  };

  useEffect(() => {
    if (scrolling) {
      const interval = setInterval(() => scrollContainer(scrolling), 10);
      return () => clearInterval(interval);
    }
  }, [scrolling]);

  useEffect(() => {
    if (containerRef.current) {
      setParent(containerRef.current);
    }
  }, [containerRef]);

  return (
    <>
      {parent && parent.scrollLeft > 0 && (
        <div
          aria-hidden="true"
          className="scroll-zone scroll-left"
          onMouseEnter={() => startScrolling('left')}
          onMouseLeave={stopScrolling}
        ></div>
      )}
      <div
        aria-hidden="true"
        className="scroll-zone scroll-right"
        onMouseEnter={() => startScrolling('right')}
        onMouseLeave={stopScrolling}
      ></div>
    </>
  );
};

export default ScrollZone;
